export const creaditNotePrintData = {
    company: {
      name: 'Northern THC Group Ltd 2',
      address: '123 Main St, Toronto',
      phone: '(416) 988-7816',
      email: 'dw@northerntnc.com',
      website: 'www.northerntnc.com'
    },
    supplier: 'Supplier XYZ',
    creditNoteNumber: 'PO-0001',
    creditNoteDate: '2025-04-29',
    invoiceNumber: 'INV-0005',
    poNumber: 'PO-0001',
    currency: 'CAD',
    purchaseOrderTo: 'Canuck Cannabis',
    shipTo: 'Northern THC Group Ltd',
    summary: {
      creditNote: { 'Before Tax': '12.24', 'PST': '0.86', 'GST/HST': '0.61', 'Total': '13.71' },
      additionalCosts: { 'Before Tax': '5', 'PST': '0.35', 'GST/HST': '0.25', 'Total': '5.60' },
      total: { 'Before Tax': '17.24', 'PST': '1.21', 'GST/HST': '0.86', 'Total': '19.31' }
    },
    notes: 'Refund for returned cannabis stock'
  }